import * as Crypto from "crypto-js";

const APP_SECRET = "developerebasset";

export function isJSON(data) {
  try {
    const object = JSON.parse(data);
    return true;
  } catch (err) {
    return false;
  }
}

export function encrypt(data) {
  const object = typeof data == "object" ? JSON.stringify(data) : data;
  return Crypto.Rabbit.encrypt(object, APP_SECRET).toString();
}

export function decrypt(data) {
  const predicate = Crypto.Rabbit.decrypt(data, APP_SECRET).toString(
    Crypto.enc.Utf8
  );
  return isJSON(predicate) ? JSON.parse(predicate) : predicate;
}
